module.exports = __webpack_public_path__ + "static/media/P3B.77222286.png";